import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { UserService } from '../../../core/services/user.service';
import { MediaUploadService } from '../../../core/services/mediaUpload.service';
import { AddCertificationModalComponent } from '../add-certification-modal/add-certification-modal.component';
import { EllipsisPipe } from '../../pipes/ellipsis.pipe';
import { NgStyle } from '@angular/common';
import { LogoBackgroundDirective } from '../../directives/logo-background.directive';

@Component({
    selector: 'certification-video',
    templateUrl: './certification-video.component.html',
    styleUrls: ['./certification-video.component.scss'],
    imports: [NgStyle, EllipsisPipe, LogoBackgroundDirective]
})
export class CertificationVideoComponent implements OnInit {

	public fileServerUrl: string = environment.urls.fileServerUrl_Obj;

	@Input() data: any = null;
	@Output() deleteFn: EventEmitter<any> = new EventEmitter<any>();

	public ctrl: string = 'PROFILE_ADD_CER';
	public isSaved: boolean = true;
	public numLimit: number = 285;
	public showReadLess: any;
	public loadingButton: boolean = false;
	public pageStatus: any;

	constructor(public modalService: NgbModal,
		private sanitizer: DomSanitizer,
		private userService: UserService,
		private mediaUploadService: MediaUploadService) { }

	ngOnInit() {
		if (this.data.VideoUrl) {
			this.data.hasVideo = true;
		} else {
			this.data.hasVideo = false;
		}

		// set video url as trusted & append file server (guard against already-absolute URLs)
		if (!this.data.isLocalVideo && this.data.hasVideo) {
			if (!this.data.VideoUrl.startsWith('http')) {
				this.data.VideoUrl = this.fileServerUrl + this.data.VideoUrl;
			}
		}

	}

	getImageSrc(imageUrl: any) {
		if (imageUrl) {
			if (imageUrl.includes(this.fileServerUrl)) {
				return imageUrl;
			} else {
				return this.fileServerUrl + imageUrl;
			}
		} else {
			return '';
		}
	}

	readMore() {
		this.numLimit = 2000;
		this.showReadLess = true;
	}

	readLess() {
		this.numLimit = 285;
		this.showReadLess = false;
	}

	edit() {
		this.pageStatus = 1;
		let modal = this.modalService.open(AddCertificationModalComponent,
			{ windowClass: 'dual-column-dialog edit-resume-dialog', backdrop: 'static', keyboard: false });
		modal.componentInstance.data = this.data;
		modal.componentInstance.pageStatus = this.pageStatus;
		modal.componentInstance.ctrl = this.ctrl;
		modal.componentInstance.delete = true;
		modal.componentInstance.certificateEditFn.subscribe((data: any) => {
			this.certificateEdit(data);
		});
		modal.componentInstance.deleteFn.subscribe((data: any) => {
			this.delete();
		});
	}

	delete() {
		let objToUpload = {
			DeleteIds: [
				{
					Type: 'CERTIFICATE',
					Id: this.data.Id,
				},
			],
		};
		this.userService.profileUpdate(objToUpload).subscribe((response: any) => {
			if (response.Code === 200) {
				this.deleteFn.emit(this.data.COGUID);
			}
		});
	}

	certificateEdit(args: any) {
		if (args.data.key === this.data.COGUID && args.ctrl === this.ctrl) {
			// show loading
			this.loadingButton = true;
			let obj = args.data.value;
			let newData = {
				Authority: {
					Id: obj.authorityId,
					Name: obj.authority,
					LogoUrl: obj.autorityUrl,
				},
				COGUID: args.data.key,
				CertificateId: obj.id,
				EndDate: obj.endYear,
				Id: obj.id,
				LicenceNumber: obj.licenceNumber,
				Notes: obj.notes,
				StartDate: obj.startYear,
				Title: obj.certificateName,
				VideoUrl: obj.videoUrl,
				ThumbnailUrl: this.data.ThumbnailUrl,
				hasVideo: !(
					obj.videoUrl.toString() === '' ||
					obj.videoUrl.toString() === this.fileServerUrl
				),
				isSaved: true,
			};
			this.data = newData;
			if (args.videoEditted) {
				this.data.VideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(obj.videoUrl);
			}
			let objToUpload = {
				UpdateRecords: [
					{
						Type: 'CERTIFICATE',
						Data: {
							Id: obj.id,
							Title: obj.certificateName,
							COGUID: args.data.key,
							AuthorityId: obj.authority,
							StartDate: obj.startYear,
							EndDate: obj.endYear,
							LicenceNumber: obj.licenceNumber,
							Notes: obj.notes,
						},
					},
				],
			};

			this.userService.profileUpdate(objToUpload).subscribe((response: any) => {
				if (args.videoEditted) {
					this.mediaUploadService.uploadVideo(
						obj.videoData,
						'CERTI_VIDEO',
						obj.id)
						.subscribe((response: any) => {
							const thumbnailUrl = response.ThumbnailURL?.startsWith('http') ? response.ThumbnailURL : this.fileServerUrl + response.ThumbnailURL;
							this.data.ThumbnailUrl = thumbnailUrl;
							this.data.VideoUrl = thumbnailUrl.replace('/images/', '/videos/').replace('.png', '.mp4');
							this.data.hasVideo = true;
							// show loading
							this.loadingButton = false;
						});
				} else if (args.videoDeleted) {
					this.data.VideoUrl = '';
					this.data.ThumbnailUrl = '';
					this.data.hasVideo = false;
					// show loading
					this.loadingButton = false;
				} else {
					// show loading
					this.loadingButton = false;
				}
			});

		}
	}

}
